import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';
import SelectAsync from 'react-select/async';
import DatePicker from 'react-datepicker2';
//https://s-yadav.github.io/react-number-format/docs/numeric_format/
import NumberFormat from 'react-number-format';

export default class Supply extends Base {
    constructor(props) {
        super(props);
        this.state = {
            caller: props.Caller,
            controllerName: 'supply',
            refreshCallerAfterSave: this.isNull(props.RefreshCallerAfterSave) ? true : props.RefreshCallerAfterSave,
            id: this.isNull(props.Id) ? this.defaultGuid() : props.Id,
            type: props.Type,
            data: null,
            loading: true,
        };
        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentDidMount() {
        this.addKeyDown();
        this.httpPost('api/v1/supply/get', {
            id: this.state.id,
            type: this.state.type,
        }).then((data) => {
            if (data.status === -1) window.location.href = '/login';
            if (data.status === 1) {
                window.organizationId = data.global.company.id;
                this.state.data = data;
                this.state.loading = false;
                this.updateFormula();
            } else {
                this.showErorrMessage(data.message);
                this.setState({
                    loading: false,
                });
            }
        });
    }
    save(e, status) {
        e.preventDefault();
        if (this.isBlank(this.state.data.record.number)) this.state.data.record.number = 0;

        this.httpPost('api/v1/supply/save', {
            id: this.state.id,
            organizationId: this.state.data.global.company.id,
            number: this.state.data.record.number,
            date: this.convertMomentToDb(this.state.data.record.date),
            description: this.state.data.record.description,
            note: this.state.data.record.note,
            status,
            type: this.state.data.record.type,
            items: this.state.data.record.items,
        }).then((data) => {
            if (data.status === -1) window.location.href = '/login';
            if (data.status === 1) {
                this.showSuccessMessage('درخواست با موفقیت ذخیره شد');

                if (this.state.refreshCallerAfterSave)
                    this.state.caller.refreshData();

                this.closeMe();
            } else {
                this.showErorrMessage(data.message);
                this.setState({
                    loading: false,
                });
            }
        });
    }
    getBlankRow(defaultIndex = null) {
        return {
            id: this.uuidv4(),
            index: defaultIndex == null ? this.state.data.record.items.length + 1 : defaultIndex,
            stuffId: this.defaultGuid(),
            stuffName: '',
            count: 0,
            supliedCount: 0,
            description: '',
            unitId: this.defaultGuid(),
            unitName: '',
            modulusCount: 0,
            modulusUnitId: this.getDefaultGuid(),
            modulusUnitName: '',
            modulusUnitRate: 0,
            productionLineId: this.getDefaultGuid(),
            productionLineName: '',            
        };
    }
    addBlankRow() {
        this.state.data.record.items.push(this.getBlankRow());
    }
    removeRow(id) {
        var temp = [];
        var index = 1;
        this.state.data.record.items
            .sort((a, b) => a.index - b.index)
            .forEach((r) => {
                if (r.id != id) {
                    temp.push(r);
                    temp[temp.length - 1].index = index;
                    index++;
                }
            });
        this.state.data.record.items = temp;
        this.updateFormula();
    }
    copyRow(id) {
        var clone = null;
        this.state.data.record.items.forEach((i) => {
            if (i.id === id) {
                clone = Object.assign({}, i);
            }
        });
        clone.id = this.uuidv4();
        var startIndex = clone.index;
        for (var i = 0; i < this.state.data.record.items.length; i++) {
            if (this.state.data.record.items[i].index > startIndex)
                this.state.data.record.items[i].index++;
        }
        clone.index++;
        this.state.data.record.items.push(clone);
        this.updateFormula();
    }
    upIndex(id) {
        var idIndex = -1;
        this.state.data.record.items.forEach((r, index) => {
            if (r.id == id) idIndex = index;
        });
        if (idIndex != -1 && idIndex > 0) {
            var ii = this.state.data.record.items[idIndex].index;
            this.state.data.record.items[idIndex].index = ii - 1;
            this.state.data.record.items[idIndex - 1].index = ii;
            this.setState({ data: this.state.data });
        }
    }
    downIndex(id) {
        var idIndex = -1;
        this.state.data.record.items.forEach((r, index) => {
            if (r.id == id) idIndex = index;
        });
        if (idIndex != -1 && idIndex < this.state.data.record.items.length - 1) {
            var ii = this.state.data.record.items[idIndex].index;
            this.state.data.record.items[idIndex].index = ii + 1;
            this.state.data.record.items[idIndex + 1].index = ii;
            this.setState({ data: this.state.data });
        }
    }
    updateModulusCount(i) {
        this.state.data.record.items[i]['modulusCount'] = this.state.data.record.items[i]['count'] * this.state.data.record.items[i]['modulusUnitRate'];
    }
    updateMainCount(i) {
        if (this.state.data.record.items[i]['modulusUnitRate'] === 0) this.state.data.record.items[i]['count'] = 0;
        this.state.data.record.items[i]['count'] = this.FixedPointNumber((this.state.data.record.items[i]['modulusCount'] / this.state.data.record.items[i]['modulusUnitRate']), 3);
    }
    setBodyValue(id, field, value) {
        for (var i = 0; i < this.state.data.record.items.length; i++) {
            if (this.state.data.record.items[i].id === id) {
                if (field == 'stuffId' || field == 'unitId' || field == 'productionLineId') {
                    if (field == 'stuffId') {
                        this.state.data.record.items[i][field] = value.value;
                        this.state.data.record.items[i]['count'] = value.defaultAmount;
                        if (!this.isNull(value.description))
                            this.state.data.record.items[i]['description'] = value.description;
                        this.state.data.record.items[i]['unitId'] = value.unitId;
                        this.state.data.record.items[i]['unitName'] = value.unitName;
                        this.state.data.record.items[i]['modulusUnitId'] = value.modulusUnitId;
                        this.state.data.record.items[i]['modulusUnitName'] = value.modulusUnitName;
                        this.state.data.record.items[i]['modulusUnitRate'] = value.modulusUnitRate;
                        this.state.data.record.items[i]['stuffName'] = value.label;

                        this.updateModulusCount(i);
                    }
                    if (field == 'unitId') {
                        this.state.data.record.items[i][field] = value.value;
                        this.state.data.record.items[i]['unitName'] = value.label;
                    }
                    if (field == 'productionLineId') {
                        this.state.data.record.items[i][field] = value.value;
                        this.state.data.record.items[i]['productionLineName'] = value.label;
                    }
                } else {
                    this.state.data.record.items[i][field] = value;
                }

                if (field == 'count') {
                    this.updateModulusCount(i);
                }
                if (field == 'modulusCount') {
                    this.updateMainCount(i);
                }
            }
        }
        this.updateFormula();
    }
    updateFormula() {

        var hasBlankRow = false;

        for (var i = 0; i < this.state.data.record.items.length; i++) {
            if (this.state.data.record.items[i].stuffId == this.defaultGuid())
                hasBlankRow = true;
        }

        if (!hasBlankRow) this.addBlankRow();

        this.setState({ date: this.state.data });
    }
    //override
    remove() {
        var id = this.state.id_to_remove;
        if (this.isNull(id) && !this.isNull(this.state.selectedIds)) id = this.state.selectedIds;

        this.httpPost("api/v1/" + this.state.controllerName + "/remove", {
            id,
            companyId: this.state.data.global.company.id,
            organizationId: this.state.data.global.company.id,
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage("اطلاعات با موفقیت حذف گردید");
                    this.state.caller.refreshData();
                    this.closeMe();
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({ showConfirmRemove: false });
                }
            })
            .catch(err => {
                this.showErorrMessage("پاسخی دریافت نشد.لطفا مجدد تلاش نمایید.");
            });
    }
    getLastBodyId() {
        return this.state.data.record.items.sort((a, b) => b.index - a.index)[0].id;
    }
    renderForm() {
        const customStyles = {
            control: (base, state) => ({
                ...base,
                border: "none",
                boxShadow: "none",
                backgroundColor: "transparent",
                minHeight: "30px",
                height: "30px",
                fontSize: "14px",
            }),
            dropdownIndicator: (base) => ({
                ...base,
                padding: 4,
            }),
            clearIndicator: (base) => ({
                ...base,
                padding: 4,
            }),
            valueContainer: (base) => ({
                ...base,
                padding: "0 6px",
            }),
            input: (base) => ({
                ...base,
                margin: 0,
                padding: 0,
            }),
            menu: (base) => ({
                ...base,
                zIndex: 9999,
            }),
        };
        return [
            <div className="modal-backdrop fade show"></div>,
            <div className="modal fad  modal-full-96 show opened" tabIndex="-1" role="dialog">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            {this.state.data.record.type === 1 && <span className="modal-title">درخواست کالا از انبار</span>}
                            {this.state.data.record.type === 2 && <span className="modal-title">سفارش خرید کالا</span>}
                            <button type="button" className="btn-close" data-dismiss="modal" aria-label="Close" onClick={(e) => this.closeMe()}>
                                <span>×</span>
                            </button>
                        </div>
                        <div className="modal-body" style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                            <div className="row">
                                <div className="col-lg-1">
                                    <label className="form-label">تاریخ</label>
                                    <DatePicker
                                        inputReadOnly={false}
                                        className="form-input input-sm persian-date"
                                        placeholder={'تاریخ'}
                                        isGregorian={false}
                                        showTodayButton={true}
                                        timePicker={false}
                                        onChange={(e) => {
                                            this.state.data.record.date = e;
                                        }}
                                        value={this.getFormatedDateForDatePicker(
                                            this.state.data.record.date
                                        )}
                                    />
                                </div>
                                <div className="col-lg-1">
                                    <label className="form-label">شماره</label>
                                    <input
                                        onChange={(e) => (this.state.data.record.number = parseInt(e.target.value))}
                                        defaultValue={this.state.data.record.number}
                                        autoComplete="off"
                                        type="text"
                                        className="form-input ltr"
                                        maxLength="20"
                                    />
                                </div>
                                <div className="col-md-10">
                                    <label className="form-label">توضیحات</label>
                                    <input
                                        onChange={(e) => (this.state.data.record.description = e.target.value)}
                                        defaultValue={this.state.data.record.description}
                                        autoComplete="off"
                                        type="text"
                                        className="form-input"
                                        style={{ width: '100%' }}
                                        maxLength="150"
                                    />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-12">
                                    <table className="invoices-table persons-table">
                                        <thead>
                                            <tr>
                                                <th style={{ width: '30px' }}>#</th>
                                                <th>آیتم</th>
                                                {this.state.data.record.type === 1 && <th>خط تولید</th>}
                                                <th>شرح</th>
                                                <th style={{ width: '80px' }}>
                                                    <span>تعداد/مقدار درخواستی</span>
                                                </th>
                                                {(this.state.data.record.status === 1 || this.state.data.record.status === 3) && <th style={{ width: '80px' }}>
                                                    <span>تعداد/مقدار تایید شده</span>
                                                </th>}
                                                <th>واحد اصلی</th>
                                                {this.state.data.global.company.stuffSubUnitEnable === 2 && <th style={{ width: '80px' }}>
                                                    <span>تعداد/مقدار فرعی</span>
                                                </th>}
                                                {this.state.data.global.company.stuffSubUnitEnable === 2 && <th>واحد فرعی</th>}
                                                <th style={{ width: '35px' }}></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.data.record.items.sort((a, b) => a.index - b.index).map((item, index) => (
                                                <tr key={item.id}>
                                                    <td>
                                                        <label>{index + 1}</label>
                                                        <div className="d-flex invoice-arrow-container">
                                                            {index > 0 &&
                                                                index != this.state.data.record.items.length - 1 && (
                                                                    <a onClick={(e) => this.upIndex(item.id)} title="انتقال به بالا">
                                                                        <i className="mir-arrow-up2 text-soft-pink "></i>
                                                                    </a>
                                                                )}
                                                            {index < this.state.data.record.items.length - 2 && (
                                                                <a onClick={(e) => this.downIndex(item.id)} title="انتقال به پایین" >
                                                                    <i className="mir-arrow-down2 text-color-blue-46"></i>
                                                                </a>
                                                            )}
                                                        </div>
                                                    </td>
                                                    <td key={"stuff_" + item.stuffId}>
                                                        <SelectAsync
                                                            style={customStyles}
                                                            defaultValue={
                                                                item.stuffId != this.defaultGuid()
                                                                    ? [
                                                                        {
                                                                            value: item.stuffId,
                                                                            label: item.stuffName,
                                                                        },
                                                                    ]
                                                                    : null
                                                            }
                                                            isMulti={false}
                                                            placeholder="انتخاب"
                                                            noOptionsMessage={({ inputValue }) =>
                                                                inputValue ? "نتیجه‌ای یافت نشد" : null
                                                            }
                                                            components={{
                                                                DropdownIndicator: () => null,
                                                                IndicatorSeparator: () => null,
                                                            }}
                                                            defaultOptions={[]}
                                                            loadOptions={this.loadStuffsOptions}
                                                            onChange={(e) =>
                                                                this.setBodyValue(item.id, 'stuffId', e)
                                                            }
                                                        />
                                                    </td>
                                                    {this.state.data.record.type === 1 && <td>
                                                        <SelectAsync
                                                            style={customStyles}
                                                            defaultValue={
                                                                item.productionLineId != this.defaultGuid()
                                                                    ? [
                                                                        {
                                                                            value: item.productionLineId,
                                                                            label: item.productionLineName,
                                                                        },
                                                                    ]
                                                                    : null
                                                            }
                                                            isMulti={false}
                                                            placeholder="انتخاب"
                                                            noOptionsMessage={({ inputValue }) =>
                                                                inputValue ? "نتیجه‌ای یافت نشد" : null
                                                            }
                                                            components={{
                                                                DropdownIndicator: () => null,
                                                                IndicatorSeparator: () => null,
                                                            }}
                                                            defaultOptions={[]}
                                                            loadOptions={this.loadProductionLinesOptions}
                                                            onChange={(e) =>
                                                                this.setBodyValue(item.id, 'productionLineId', e)
                                                            }
                                                        />
                                                    </td>}
                                                    <td>
                                                        <input
                                                            type="text"
                                                            className="form-input text-center"
                                                            defaultValue={item.description}
                                                            onChange={(e) =>
                                                                this.setBodyValue(
                                                                    item.id,
                                                                    'description',
                                                                    e.target.value
                                                                )
                                                            }
                                                        />
                                                    </td>
                                                    <td>
                                                        <NumberFormat
                                                            value={item.count}
                                                            onChange={(e) =>
                                                                this.setBodyValue(
                                                                    item.id,
                                                                    'count',
                                                                    parseFloat(e.target.value.replace(/,/g, ''))
                                                                )
                                                            }
                                                            thousandSeparator={true}
                                                            prefix={''}
                                                            className="form-input text-center ltr"
                                                        />
                                                    </td>
                                                    {(this.state.data.record.status === 1 || this.state.data.record.status === 3) &&
                                                        <td>
                                                            <NumberFormat
                                                                value={item.supliedCount}
                                                                onChange={(e) =>
                                                                    this.setBodyValue(
                                                                        item.id,
                                                                        'supliedCount',
                                                                        parseFloat(e.target.value.replace(/,/g, ''))
                                                                    )
                                                                }
                                                                thousandSeparator={true}
                                                                prefix={''}
                                                                className="form-input text-center ltr"
                                                            />
                                                        </td>}
                                                    <td>{item.unitName}</td>
                                                    {this.state.data.global.company.stuffSubUnitEnable !== 2 ? null : <td>
                                                        <NumberFormat value={item.modulusCount} onChange={e => this.setBodyValue(item.id, 'modulusCount', parseFloat(e.target.value.replace(/,/g, '')))} thousandSeparator={true} prefix={''} className='form-input text-center ltr' />
                                                    </td>}
                                                    {this.state.data.global.company.stuffSubUnitEnable === 2 && <td>{item.modulusUnitName}</td>}
                                                    <td>
                                                        <div className="item-actions">
                                                            {item.stuffId != this.defaultGuid() && (
                                                                <button title="حذف سطر" onClick={(e) => this.removeRow(item.id)} className="item-delete-btn">
                                                                    <i className="mir-trash text-danger"></i>
                                                                </button>
                                                            )}
                                                            {item.stuffId != this.defaultGuid() &&
                                                                <button title="کپی سطر" onClick={(e) => this.copyRow(item.id)} className="item-copy-btn" >
                                                                    <img src="assets/images/icons/copy-item-left-bottom.svg" />
                                                                </button>
                                                            }
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div className="mobile-table">
                                {this.state.data.record.items.sort((a, b) => a.index - b.index).map((item, index) => (
                                    <div className="card p-3 row mt-2 flex justify-content-between" key={"mobile_" + item.id}>
                                        <div>
                                            <b>ردیف: </b>
                                            <span>{index + 1}</span>
                                            <div className="d-flex invoice-arrow-container">
                                                {index > 0 &&
                                                    index != this.state.data.record.items.length - 1 && (
                                                        <span
                                                            onClick={(e) => this.upIndex(item.id)}
                                                            title="انتقال به بالا"
                                                        >
                                                            <i className="mir-arrow-up2 text-soft-pink "></i>
                                                        </span>
                                                    )}
                                                {index < this.state.data.record.items.length - 2 && (
                                                    <span
                                                        onClick={(e) => this.downIndex(item.id)}
                                                        title="انتقال به پایین"
                                                    >
                                                        <i className="mir-arrow-down2 text-color-blue-46"></i>
                                                    </span>
                                                )}
                                            </div>
                                        </div>
                                        <div key={"stuff_" + item.stuffId}>
                                            <b>آیتم: </b>
                                            <SelectAsync
                                                style={customStyles}
                                                defaultValue={
                                                    item.stuffId != this.defaultGuid()
                                                        ? [
                                                            {
                                                                value: item.stuffId,
                                                                label: item.stuffName,
                                                            },
                                                        ]
                                                        : null
                                                }
                                                isMulti={false}
                                                placeholder="انتخاب"
                                                noOptionsMessage={({ inputValue }) =>
                                                    inputValue ? "نتیجه‌ای یافت نشد" : null
                                                }
                                                components={{
                                                    DropdownIndicator: () => null,
                                                    IndicatorSeparator: () => null,
                                                }}
                                                defaultOptions={[]}
                                                loadOptions={this.loadStuffsOptions}
                                                onChange={(e) =>
                                                    this.setBodyValue(item.id, 'stuffId', e)
                                                }
                                            />
                                        </div>
                                        <div>
                                            <b>شرح: </b>
                                            <input
                                                type="text"
                                                className="form-input text-center"
                                                defaultValue={item.description}
                                                onChange={(e) =>
                                                    this.setBodyValue(
                                                        item.id,
                                                        'description',
                                                        e.target.value
                                                    )
                                                }
                                            />
                                        </div>
                                        <div>
                                            <b>تعداد: </b>
                                            <NumberFormat
                                                value={item.count}
                                                onChange={(e) =>
                                                    this.setBodyValue(
                                                        item.id,
                                                        'count',
                                                        parseFloat(e.target.value.replace(/,/g, ''))
                                                    )
                                                }
                                                thousandSeparator={true}
                                                prefix={''}
                                                className="form-input text-center ltr"
                                            />
                                        </div>
                                        {(this.state.data.record.status === 1 || this.state.data.record.status === 3) &&
                                            <div>
                                                <span>تعداد/مقدار تایید شده</span>
                                                <NumberFormat
                                                    value={item.supliedCount}
                                                    onChange={(e) =>
                                                        this.setBodyValue(
                                                            item.id,
                                                            'supliedCount',
                                                            parseFloat(e.target.value.replace(/,/g, ''))
                                                        )
                                                    }
                                                    thousandSeparator={true}
                                                    prefix={''}
                                                    className="form-input text-center ltr"
                                                />
                                            </div>}
                                        <div>{item.unitName}</div>
                                        {this.state.data.global.company.stuffSubUnitEnable === 2 && <div>{item.modulusCount}</div>}
                                        {this.state.data.global.company.stuffSubUnitEnable === 2 && <div>{item.modulusUnitName}</div>}
                                        {this.state.data.record.source === 1 && <div>
                                            <div className="item-actions">
                                                {item.stuffId != this.defaultGuid() && (
                                                    <button title="حذف سطر" onClick={(e) => this.removeRow(item.id)} className="item-delete-btn" >
                                                        <i className="mir-trash text-danger"></i>
                                                    </button>
                                                )}
                                                {item.stuffId != this.defaultGuid() &&
                                                    <button title="کپی سطر" onClick={(e) => this.copyRow(item.id)} className="item-copy-btn">
                                                        <img src="assets/images/icons/copy-item-left-bottom.svg" />
                                                    </button>
                                                }
                                            </div>
                                        </div>}
                                    </div>
                                ))}
                            </div>

                            <div className="row" style={{ paddingLeft: '15px' }}>
                                <div className="col-lg-12 col-md-12 col-lg-12">
                                    <label className="form-label">یادداشت</label>
                                    <input onChange={(e) => (this.state.data.record.note = e.target.value)} defaultValue={this.state.data.record.note} className="form-input" maxLength="250" />
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer flex flex-row gap-4">
                            <a className="btn btn-secendry" onClick={(e) => this.closeMe()}>انصراف</a>
                            {this.state.data.record.id !== this.defaultGuid() && <a className="btn btn-danger" onClick={e => this.confirmRemove(this.state.data.record.id)} >حذف</a>}
                            {this.state.data.record.id !== this.defaultGuid() && <a onClick={(e) => this.getPdf(this.state.data.record.id)} className="btn btn-blue">PDF</a>}
                            {this.state.data.record.status === 0 && <a onClick={(e) => this.save(e, 0)} className="btn btn-success">ذخیره - پیش نویس</a>}
                            {this.state.data.record.status === 1 && <a onClick={(e) => this.save(e, 3)} className="btn btn-success">ذخیره - تایید</a>}
                            {this.state.data.record.status === 1 && <a onClick={(e) => this.save(e, 2)} className="btn btn-danger">ذخیره - رد</a>}
                            {this.state.data.record.status === 0 && <a onClick={(e) => this.save(e, 1)} className="btn btn-success">ذخیره - ارسال</a>}
                        </div>
                    </div>
                </div>
            </div>
        ];
    }
    render() {
        if (!this.isBlank(this.state.redirect))
            return <Navigate to={this.state.redirect} />;

        let contents = this.state.loading
            ? this.renderLoading()
            : [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                this.renderForm(),
                this.renderPopupComponent(),
            ];

        return contents;
    }
}